class SiblingSwatches {
  constructor() {
    document.addEventListener('click', this.handleClick.bind(this), { passive: false });
  }

  handleClick(e) {
    const swatch = e.target.closest('.sibling-swatch-color');
    if (!swatch) return;

    e.preventDefault();

    const card = swatch.closest('.product-card');
    if (!card) return;

    // Bild tauschen
    const newSrc = swatch.dataset.image;
    const newSrcset = swatch.dataset.imageSrcset;

    if (newSrc) {
      const mainImage = card.querySelector('.product-card__image--primary');
      if (mainImage) {
        mainImage.src = newSrc;
        if (newSrcset) mainImage.srcset = newSrcset;
      }
    }

    // Alle Produkt-Links umbiegen
    const newHref = swatch.dataset.href;
    if (newHref) {
      card.querySelectorAll('a[data-instant]').forEach(link => {
        link.setAttribute('href', newHref);
      });
    }

    // Aktiven Swatch markieren
    card.querySelectorAll('.sibling-swatch-color').forEach(s => {
      s.style.border = '1px solid #d1d1d1';
      s.style.outline = 'none';
    });
    swatch.style.border = '2px solid #000';
    swatch.style.outline = '1px solid #fff';
    swatch.style.outlineOffset = '-3px';
  }
}

new SiblingSwatches();